var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sh-doc-card',{attrs:{"content-path":"/privacy.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }